import React, { useMemo, useState } from 'react'

import LessMoreText from '../../component/LessMoreText'
import { CRRender, EmailTag, LinkTag } from '../../component/crRender'
import ImgPopup from '../../component/popups/imgPopup'
import { FormatePhone, Localizer } from '../../utils'
import { PROVIDER_REQUEST_SCREENS, PROVIDER_REQUEST_STATUS } from '../../data/Constant'
import Tabs from '../../component/tabs'
import Accepted from './Accepted'
import Rejected from './Rejected'
import Pending from './Pending'
import './style.css'

const TabsSection = (activeStatus, setter) => {
    return (
        <Tabs  List={Localizer(PROVIDER_REQUEST_SCREENS)} onApply={setter} activeTab={activeStatus} />
    )
}
const ProvidersRR = () => {

    const [activeStatus, setActiveStatus] = useState(1)

    const columns = useMemo(() => [
        { Header: "request-id", accessor: "id", canSearch: true },
        { Header: "provider-name", accessor: "providerName", canSearch: true },
        { Header: "status", Cell: ({ row: { original } }) => <>{original?.status}</> },
        { Header: "submission-at", accessor: "createdAt" },
    ], [])


    return (
        <>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Pending}>
                <Pending columns={columns} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Accepted}>
                <Accepted columns={columns} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Rejected}>
                <Rejected columns={columns} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
        </>

    )
}

export default ProvidersRR
